import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleHeading1, ArticleHeading2, LinkButton, Overline, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import styles from './EtazhiBlackFridayTopBanner.css';
import { trackBannerClick, trackBannerShow } from './tracking';
import { selectEtazhiBlackFridayBannerData, selectEtazhiBlackFridaySerpLink } from 'shared/selectors/etazhiBlackFriday';
import { selectJsonQuery } from 'shared/selectors/results';

interface IEtazhiBlackFridayTopBannerProps {
  isButtonVisible: boolean;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const EtazhiBlackFridayTopBanner: React.FC<IEtazhiBlackFridayTopBannerProps> = props => {
  const { isButtonVisible } = props;
  const jsonQuery = useSelector(selectJsonQuery);
  const bannerData = useSelector(selectEtazhiBlackFridayBannerData);
  const serpLink = useSelector(selectEtazhiBlackFridaySerpLink);

  const handleButtonClick = React.useCallback(() => {
    trackBannerClick(jsonQuery);
  }, [jsonQuery]);

  const onBannerShown = React.useCallback(() => {
    trackBannerShow(jsonQuery);
  }, [jsonQuery]);

  if (!bannerData || !bannerData.enabled) {
    return null;
  }

  const { bgImageUrl, logoImageUrl, title, subtitle, footerText, buttonText } = bannerData;

  return (
    <ActionAfterViewObserver callback={onBannerShown} triggerOnce>
      <div className={styles['banner']} data-testid="EtazhiBlackFridayTopBanner">
        {bgImageUrl && <div className={styles['bg-image']} style={{ backgroundImage: `url(${bgImageUrl})` }} />}
        <div className={styles['content']}>
          {logoImageUrl && <div className={styles['logo']} style={{ backgroundImage: `url(${logoImageUrl})` }} />}
          <div className={styles['texts']}>
            <span className={styles['advertisement']}>
              <Overline color="text-secondary-default">Реклама</Overline>
            </span>
            {title && (
              <div className={styles['title']}>
                <ArticleHeading1 color="text-inverted-default">{title}</ArticleHeading1>
              </div>
            )}
            {subtitle && <ArticleHeading2 color="text-inverted-default">{subtitle}</ArticleHeading2>}
          </div>
          {isButtonVisible && buttonText && (
            <div className={styles['button']}>
              <LinkButton
                href={serpLink}
                theme="fill_white_primary"
                onClick={handleButtonClick}
                data-testid="etazhi-black-friday-button"
              >
                {buttonText}
              </LinkButton>
            </div>
          )}
        </div>
        {footerText && (
          <div className={styles['annotation']}>
            <div className={styles['annotation-text']}>
              <UIText3 color="text-inverted-default" whiteSpace="nowrap">
                {footerText}
              </UIText3>
            </div>
          </div>
        )}
      </div>
    </ActionAfterViewObserver>
  );
};
